const Rwd    = require("../utillity/responsive");
const Utill  = require("../utillity/utill");
const Calc   = require("../utillity/calculate");

const ScrSec = require('../animation/section_scroll');

module.exports.SetSkin = function(type, txt_color, arw_color){
	/*
		type: pagetop or scroll
		txt_color: white or black
		arw_color: white or blue
	*/

	let $PT    = $('[data-page_controller]');
	let $PT_IN = $('[data-page_controller] .page-controller__in');
	let txt = type==='pagetop'? 'PAGE TOP': 'SCROLL';

	$PT
		.attr('data-type', type)
		.attr('data-txtC', txt_color)
		.attr('data-arwC', arw_color);
	$PT_IN.text(txt);
};


module.exports.Controll = function(){
	// call by ready OR pjax:ready function
	// 初期値のみ

	if( $('body').hasClass('body--home') ) {
		this.SetSkin('scroll', 'white', 'white');
	}else {
		this.SetSkin('pagetop', 'black', 'blue');
	}
};


module.exports.Move = function(){
	let type = $('[data-page_controller]').attr('data-type');

	if( Utill.IsPage('home') ) {
		// console.log(700)
		if( type==='pagetop' ) {
			if( Utill.IsOriginAnime() ) {
				// console.log('tegfasdgjadsjkg');
				ScrSec.ChangeSec(-1, 0);
			}else {
				ScrSec.Move(0);
				return false;
			}
		}else {
			if( Utill.IsOriginAnime() ) {
				ScrSec.ChangeSec(1);
			}else {
				ScrSec.MoveNext();			
			}
		}		
	}else {
		TweenMax.to(window, Calc.ToSecond(300), {
			scrollTo: 0,
		});
	}

};



module.exports.ControllVisible = function(index){
	let last_index = $('[data-section]').length - 1;
	if( index === 0 || index === last_index ) {
		$('[data-page_controller]').show();
	}else {
		$('[data-page_controller]').hide();
	}
};


// WEBPACK FOOTER //
// ./html/_src/js_wb/dom/pagetop.js